import { cubicBezier } from 'framer-motion'

// https://cubic-bezier.com/#.59,.04,.61,1.04
export const bezierEaseIn = cubicBezier(0.59, 0.04, 0.61, 1.04)
